var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx } from "react/jsx-runtime";
import { createContext, useContext, useMemo, useReducer } from 'react';
var SET_INITIAL_DATA = 'SET_INITIAL_DATA';
var SET_CURSOR = 'SET_CURSOR';
var SET_NEXT_CURSOR = 'SET_NEXT_CURSOR';
var SET_ACTIVE_FILTER = 'SET_ACTIVE_FILTER';
var HANDLE_LOAD_MORE = 'HANDLE_LOAD_MORE';
var SET_IS_LOADING_MORE_DATA = 'SET_IS_LOADING_MORE_DATA';
var EMPTY_NEXT_CURSOR = 'EMPTY_NEXT_CURSOR';
// actions
export var setInitialData = function (payload) { return ({
    type: SET_INITIAL_DATA,
    payload: payload
}); };
export var setCursor = function (payload) { return ({
    type: SET_CURSOR,
    payload: payload
}); };
export var setNextCursor = function (payload) { return ({
    type: SET_NEXT_CURSOR,
    payload: payload
}); };
export var setActiveFilter = function (payload) { return ({
    type: SET_ACTIVE_FILTER,
    payload: payload
}); };
export var handleLoadMore = function () { return ({
    type: HANDLE_LOAD_MORE
}); };
export var setIsLoadingMoreData = function (payload) { return ({
    type: SET_IS_LOADING_MORE_DATA,
    payload: payload
}); };
export var emptyNextCursor = function () { return ({
    type: EMPTY_NEXT_CURSOR
}); };
export var reducer = function (state, action) {
    var getState = function () {
        switch (action.type) {
            case SET_INITIAL_DATA: {
                return __assign(__assign({}, state), action.payload);
            }
            case SET_CURSOR: {
                return __assign(__assign({}, state), { cursor: action.payload });
            }
            case SET_NEXT_CURSOR: {
                return __assign(__assign({}, state), { nextCursor: action.payload });
            }
            case SET_ACTIVE_FILTER: {
                return __assign(__assign({}, state), { activeFilter: action.payload, cursor: '', nextCursor: '' });
            }
            case HANDLE_LOAD_MORE: {
                return __assign(__assign({}, state), { isLoadingMoreData: true, cursor: state.nextCursor });
            }
            case SET_IS_LOADING_MORE_DATA: {
                return __assign(__assign({}, state), { isLoadingMoreData: action.payload });
            }
            case EMPTY_NEXT_CURSOR: {
                return __assign(__assign({}, state), { cursor: '', nextCursor: '' });
            }
            default:
                return state;
        }
    };
    return getState();
};
export var activityStoreInitialData = {
    cursor: '',
    setCursor: function () { },
    nextCursor: '',
    setNextCursor: function () { },
    activeFilter: 'all',
    setActiveFilter: function () { },
    handleLoadMore: function () { },
    isLoadingMoreData: false,
    setIsLoadingMoreData: function () { },
    emptyNextCursor: function () { },
    accountId: '',
    accountIdType: 'guid',
    activity: {},
    isDisplayCondensed: false,
    config: {},
    isError: false,
    isFetching: false,
    isSuccess: false,
    refetchAccountActivity: function () { },
    setInitialData: function () { },
    showLoadMore: false,
    totalTransactions: '0',
    triggerAnalyticsEvent: function () { }
};
var useActivityStore = function () {
    var _a = useReducer(reducer, activityStoreInitialData), state = _a[0], dispatch = _a[1];
    return __assign(__assign({}, state), { setCursor: function (cursor) { return dispatch(setCursor(cursor)); }, setNextCursor: function (nextCursor) { return dispatch(setNextCursor(nextCursor)); }, setActiveFilter: function (activeFilter) {
            return dispatch(setActiveFilter(activeFilter));
        }, handleLoadMore: function () { return dispatch(handleLoadMore()); }, setIsLoadingMoreData: function (isLoadingMoreData) {
            return dispatch(setIsLoadingMoreData(isLoadingMoreData));
        }, emptyNextCursor: function () { return dispatch(emptyNextCursor()); }, setInitialData: function (props) { return dispatch(setInitialData(props)); } });
};
export var ActivityContext = createContext(activityStoreInitialData);
export var ActivityProvider = function (_a) {
    var children = _a.children, overrides = _a.overrides;
    var value = useActivityStore();
    var initialState = useMemo(function () { return (__assign(__assign({}, value), overrides)); }, [value, overrides]);
    return (_jsx(ActivityContext.Provider, { value: initialState, children: children }));
};
export var useActivityContext = function () {
    return useContext(ActivityContext);
};
export default useActivityStore;
//# sourceMappingURL=activity-store.js.map